import { combineReducers } from 'redux';
import {reducer as formReducer} from 'redux-form';
import signIn from './reducer_signIn';
import dashboard from './reducer_dashboard';
import admins from './reducer_admin';
import language from './reducer_language';
import chat from './reducer_chat';
import subscription from './reducer_subscription';
import static_page from './reducer_static_page';
import email_templates from './reducer_email_templates';
import settings from './reducer_settings';
import notification from './reducer_notification';
import { routerStateReducer } from 'redux-router';

const rootReducer = combineReducers({
  // state: (state = {}) => state
    form: formReducer,
    user: signIn,
    dashboard: dashboard,
    router : routerStateReducer,
    admins: admins,
    lang: language,
    chat: chat,
    subscription: subscription,
    static_page: static_page,
    email: email_templates,
    settings: settings,
    notification: notification
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js